
const localStoragePath = 'frescoPreferenceStore'

export default {
	localStoragePath,
}